import { pendo } from '@frontend/tracking';

const BASE_EVENT_PREFIX = 'call-intel-trial';

/**
 * Pendo event names for the Call Intel PLG Free Trial experience.
 */
export const backfillPendoEvents = {
  // Page views
  loadingStateViewed: `${BASE_EVENT_PREFIX}-loading-state-viewed`,
  newCallsLoadingStateViewed: `${BASE_EVENT_PREFIX}-new-calls-loading-state-viewed`,

  // Loading state interactions
  videoPlayed: `${BASE_EVENT_PREFIX}-loading-video-played`,
  trainingCampClicked: `${BASE_EVENT_PREFIX}-training-camp-clicked`,

  // Global banner - batch 1 ready
  batch1BannerSeen: `${BASE_EVENT_PREFIX}-batch1-banner-seen`,
  batch1BannerCtaClicked: `${BASE_EVENT_PREFIX}-batch1-banner-cta-clicked`,
  batch1BannerDismissed: `${BASE_EVENT_PREFIX}-batch1-banner-dismissed`,

  // Global banner - fully complete
  fullyCompleteBannerSeen: `${BASE_EVENT_PREFIX}-fully-complete-banner-seen`,
  fullyCompleteBannerCtaClicked: `${BASE_EVENT_PREFIX}-fully-complete-banner-cta-clicked`,
  fullyCompleteBannerDismissed: `${BASE_EVENT_PREFIX}-fully-complete-banner-dismissed`,

  // Global banner - call recordings disabled
  recordingsDisabledBannerSeen: `${BASE_EVENT_PREFIX}-recordings-disabled-banner-seen`,
  recordingsDisabledBannerCtaClicked: `${BASE_EVENT_PREFIX}-recordings-disabled-banner-cta-clicked`,
  recordingsDisabledBannerDismissed: `${BASE_EVENT_PREFIX}-recordings-disabled-banner-dismissed`,
} as const;

export const trackBackfillEvent = (
  eventName: (typeof backfillPendoEvents)[keyof typeof backfillPendoEvents],
  metadata?: pendo.Metadata
) => {
  pendo.track(eventName, metadata);
};
